import React, { useEffect } from "react";

import { useForm } from "react-hook-form";

import { useParams } from "react-router-dom";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import useHttpHook from "../../../Hooks/HttpHook";
import { CreateAddonsApi } from "../../../utils/ApiConstant";

const DeleteAddonModal = (props) => {
  const { show, onClose, addonId } = props;
  const [loading, sendRequest, error] = useHttpHook();
  const { eventId } = useParams();

  const onSubmit = async (data) => {
    let response = await sendRequest(CreateAddonsApi + eventId, {
      method: "delete",
      data: {
        addonId,
      },
    });
    if (response.status === 1) {
      onClose();
      props.getAddons();
    }
  };

  return (
    <MainComponentWrapper loading={loading} errorInfo={error}>
      <ModalWrapper
        title={"Delete Addon"}
        OverRideModal={true}
        size="md"
        ShowModal={show}
        CloseModalHandler={() => {
          onClose();
        }}
        submitText={"Delete"}
        clickHandler={() => {
          onSubmit();
        }}
        formId="addonForm"
        isLoading={loading}
      >
        Are you sure you want to delete this addon?
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default DeleteAddonModal;
